import { Star, Quote } from 'lucide-react';

export default function Testimonials() {
    return (
        <section className="section-pad bg-soft">
            <div className="container-wl">
                <div className="max-w-3xl mx-auto text-center">
                    <div className="inline-flex items-center gap-3 mb-5">
                        <span className="gold-rule" />
                        <span className="overline">Client Voices</span>
                        <span className="gold-rule" />
                    </div>
                    <h2 className="font-display-bold text-ink text-4xl lg:text-[52px] leading-[1.05] tracking-tight">
                        Verified reviews, <span className="italic text-gold-600">coming soon.</span>
                    </h2>
                    <p className="mt-5 text-ink/65 text-[16px] leading-relaxed">
                        We only publish authentic Google reviews from real clients. Our Google Business
                        integration is being prepared — until then, here is what to expect.
                    </p>
                </div>

                <div className="mt-12 max-w-2xl mx-auto bg-white border border-hairline rounded-xl p-8 lg:p-10 text-center shadow-soft">
                    <div className="flex items-center justify-center gap-2 mb-5">
                        <svg className="w-6 h-6" viewBox="0 0 48 48" aria-hidden>
                            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
                            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.6 6.1 29.6 4 24 4 16.1 4 9.3 8.5 6.3 14.7z" />
                            <path fill="#4CAF50" d="M24 44c5.5 0 10.5-2.1 14.2-5.5l-6.6-5.4c-2 1.4-4.6 2.3-7.6 2.3-5.2 0-9.7-3.3-11.3-8l-6.6 5.1C9.1 39.4 16 44 24 44z" />
                            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.6 5.4C40.5 36.1 44 30.6 44 24c0-1.3-.1-2.4-.4-3.5z" />
                        </svg>
                        <span className="text-[12px] uppercase tracking-widest2 font-semibold text-ink">
                            Google Reviews
                        </span>
                    </div>

                    <Quote className="w-7 h-7 text-gold mx-auto mb-4 opacity-70" />
                    <p className="font-display text-ink text-[20px] lg:text-[22px] leading-snug italic max-w-xl mx-auto">
                        “Reviews from our 500+ clients will appear here directly from Google — verified,
                        dated, and unedited.”
                    </p>

                    <div className="mt-6 flex items-center justify-center gap-1.5 text-gold-600">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <Star key={i} className="w-4 h-4 fill-gold-400 text-gold-400" />
                        ))}
                    </div>
                    <p className="mt-3 text-[12px] text-ink/55">Authentic feedback, integrated soon.</p>
                </div>
            </div>
        </section>
    );
}
